export const environments = {
  DEV: 'development',
  STAGE: 'stage',
  PROD: 'production',
};

export const env = {
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT ?? environments.DEV,
  BASE_API_URL: process.env.REACT_APP_API_URL ?? '',
  AUCTION_URL: process.env.REACT_APP_AUCTION_URL ?? '',
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL ?? '',
  SENTRY_AUTH_TOKEN: process.env.REACT_APP_SENTRY_AUTH_TOKEN ?? '',
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN ?? '',
};

export const isDev = env.environment === environments.DEV;
